import { atom } from 'nanostores';

export const ComponentElement = (Base, className) => {
  return class extends Base {
    constructor(...args) {
      super(...args);

      this.prototypeType = className;

      if (!this.id) {
        const index = $componentsManagerIncrement.get() + 1;
        $componentsManagerIncrement.set(index);
        this.id = `${this.prototypeType.toLowerCase()}-${index}`;
      }
    }

    connectedCallback() {
      if (typeof Base.prototype.connectedCallback === 'function') {
        Base.prototype.connectedCallback.call(this);
      }

      $componentsManager.set([...$componentsManager.get(), this]);
    }

    disconnectedCallback() {
      if (typeof Base.prototype.disconnectedCallback === 'function') {
        Base.prototype.disconnectedCallback.call(this);
      }

      $componentsManager.set(
        $componentsManager.get().filter($component => $component.id !== this.id)
      );
    }
  };
};

export const $componentsManagerIncrement = atom(0);
export const $componentsManager = atom([]);

export const getComponentById = id => {
  return $componentsManager.get().find($component => $component.id === id);
};

export const getComponentsByPrototype = (prototype, selectorsToExclude = []) => {
  let excludedSelectors = [];

  if (typeof selectorsToExclude === 'string') {
    excludedSelectors = [selectorsToExclude];
  } else if (Array.isArray(selectorsToExclude)) {
    excludedSelectors = selectorsToExclude;
  } else if (selectorsToExclude instanceof HTMLElement && selectorsToExclude.id) {
    excludedSelectors = [`#${selectorsToExclude.id}`];
  }

  return $componentsManager.get().filter($component => {
    return (
      prototype === $component.prototypeType &&
      !excludedSelectors.some(selector => $component.matches(selector))
    );
  });
};
